import { render, staticRenderFns } from "./RedeemCoinManagementDetailsScreen.vue?vue&type=template&id=7e1ba8d0&scoped=true&"
import script from "./RedeemCoinManagementDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./RedeemCoinManagementDetailsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1ba8d0",
  null
  
)

export default component.exports